import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateDirective } from "@ngx-translate/core";
import { BreadcrumbLink, BreadcrumbNavigationService } from "~app/common/services/breadcrumb-navigation.service";

@Component({
    selector: "rask-breadcrumb-navigation",
    templateUrl: "./breadcrumb-navigation.component.html",
    styleUrls: ["./breadcrumb-navigation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterLink,
        TranslateDirective
    ]
})
export class BreadcrumbNavigationComponent {
    private readonly breadcrumbService = inject(BreadcrumbNavigationService);

    getStates(): BreadcrumbLink[] {
        return this.breadcrumbService.links;
    }

}
